import { useState } from "react";

export default function useExpandableRows() {
  const [expandedRows, setExpandedRows] = useState(new Set());

  const toggleRow = (rowId) => {
    setExpandedRows((prev) => {
      const next = new Set(prev);
      next.has(rowId) ? next.delete(rowId) : next.add(rowId);
      return next;
    });
  };

  const isExpanded = (rowId) => expandedRows.has(rowId);

  return { expandedRows, toggleRow, isExpanded };
}
